import React from 'react';
import { reduxForm, Field } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet';
import MenuTitle from 'components/MenuTitle';
import { sendClevertapChangeOutletTracker } from 'actions/setting/receipt';
import styles from './ActionBar.css';

class ActionBar extends React.Component {
  render() {
    const { outlets } = this.props;
    return (
      <div>
        <MenuTitle menuTitle="Receipt" />
        <div className={`col-md-12 ${styles['action-bar']} outlet-receipt`}>
          <Field
            component={DropdownOutlet}
            outlets={outlets}
            onChangeOutletIds={this._onChangeOutlet}
            name="outlet"
          />
        </div>
      </div>
    );
  }

  _onChangeOutlet = outletIds => {
    const { currentOutlet } = this.props;
    const { outlets } = this.props;
    this.props.onChangeOutlet(outletIds);
    this.props.dispatch(
      sendClevertapChangeOutletTracker(outletIds, currentOutlet, outlets)
    );
  };
}

const mapForm = {
  form: 'search',
};

function mapStateToProps(state) {
  return {
    outlets: state.setting.receipt.outlets,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

ActionBar.propTypes = {
  onChangeOutlet: PropTypes.func,
};
export default reduxForm(mapForm)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ActionBar)
);
